



















































import {Vue, Component} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import DateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import DateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import {changeDateFormat} from '@/utils/dateUtils';
import {toI18n} from '@/utils/commonUtils';

@Component({
  components: {
    PageFormSelect,
    DateRangePicker,
    DateFilterBtns
  }
})
export default class ModifyPromotionText extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private today: string = changeDateFormat('', 'YYYY-MM-DD');
  private initRangeStartYmd = this.today;
  private promotionTextInfo = {text: '', periodYn: 'N'};

  private dateData: {startYmd: string; endYmd: string} = {
    startYmd: this.today,
    endYmd: this.today
  };

  private dateReceiveData = {...this.dateData};

  private dateDataChange({startYmd, endYmd}: any): void {
    this.dateReceiveData = {startYmd, endYmd};
  }

  private get counting() {
    return this.promotionTextInfo.text.length;
  }

  private get mallProductNos(): string[] {
    return this.$route.params.mallProductNos.split(',');
  }

  private get startYmd(): string {
    return `${this.dateReceiveData.startYmd}`;
  }

  private get endYmd(): string {
    return `${this.dateReceiveData.endYmd}`;
  }

  private windowSizeChange() {
    let width = 1300;
    let height = 560;

    if (this.promotionTextInfo.periodYn === 'N') {
      width = 680;
      height = 300;
    }
    $('.content').css({width, height});
    window.resizeTo(width + 40, height + 50);
  }

  private save() {
    if (this.promotionTextInfo.text === '') {
      alert(this.toI18n('PLEASE_ENTER_A_VALUE')); //값을 입력해주세요
      return;
    }

    const promotionTextInfo = {
      ...this.promotionTextInfo,
      startYmd: this.startYmd,
      endYmd: this.endYmd
    };

    const params = {
      mallProductNos: String(this.mallProductNos)
    };

    this.$api.patchProducts({params, data: {promotionTextInfo, promotionTextUseYn: this.promotionTextInfo.text === '' ? 'N' :'Y'}}).then(({data}: any): void => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      window.opener.postMessage({promotionText: true, data});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup');
    this.windowSizeChange();
    // window.moveBy(-1000, 0);

    if (this.mallProductNos.length === 1) {
      const params = {
        mallProductNo: Number(this.mallProductNos[0])
      };
      this.$api.getProductByNo({params}).then(
        ({
          data: {
            promotionTextInfo: {text, periodYn, startYmd, endYmd}
          }
        }: any) => {
          Object.assign(this.promotionTextInfo, {
            text,
            periodYn
          });

          if (periodYn === 'Y') {
            this.initRangeStartYmd = startYmd;
            Object.assign(this.dateData, {startYmd, endYmd});
          }
        }
      );
    }

    window.name = 'promotionText';
  }
}
